import { render, staticRenderFns } from "./AllCollectionTask.vue?vue&type=template&id=3883c29b&scoped=true&"
import script from "./AllCollectionTask.vue?vue&type=script&lang=js&"
export * from "./AllCollectionTask.vue?vue&type=script&lang=js&"
import style0 from "./AllCollectionTask.vue?vue&type=style&index=0&id=3883c29b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3883c29b",
  null
  
)

export default component.exports